
// value in inches
var options = [
    { 
      "name":"Australia", 
      "sizes": ["8", "10", "12","14"] 
    },
    { 
      "name":"United States", 
      "sizes": ["4", "6", "8","10"] 
    },
    { 
      "name":"United Kingdom", 
      "sizes": ["8", "10", "12","14"] 
    }
  ];

  function populateSelect() {
    var ele = document.getElementById('country-selector');
    options.forEach(function(b) {
      ele.innerHTML += '<option value="' + b.name + '">' + b.name + '</option>';
    })
  
  }


  function sizeGuideInit() { 
  document.getElementById('country-selector').addEventListener('change',function(e) {
    const valTable = e.target.value;
    const table = document.querySelector('.size-guide__tab table');
    if(!table) return;
      const firstRow = table.querySelectorAll('tr')[1];
      firstRow.querySelectorAll('td')[0].innerHTML = valTable;
      options.forEach((country,index) => {
        if(country.name == valTable) {
          const firstRow = table.querySelectorAll('tr')[1];
          firstRow.querySelectorAll('td').forEach((td,i) => {
            if(i==0) return true;
            td.innerHTML = country.sizes[i-1];
      });
        }
      });  
  });

  document.getElementById('measurement-selector').addEventListener('change',function(e) {
    const val = e.target.value;
    const tabs = document.querySelectorAll('.size-guide__tab');
    tabs.forEach(tab => {
      const cols = tab.querySelectorAll('td');
      cols.forEach((td) => {
        const cellText = td.innerHTML;
        if( cellText.indexOf('-') > -1 || cellText > -1 && td.classList.contains('in-cm')) {
          const cellValues = cellText.split('-');
          
          cellValues.forEach((n,i) => {
            if(isNaN(n)) return true;
            if(val === 'cm') {
              cellValues[i] = (n * 2.54).toFixed(2);
            } else {
              cellValues[i] = (n / 2.54).toFixed(2);
            }
          });

          td.innerHTML = cellValues.join('-');
        }
      });  
    });
  });


};
  
  




if(window.location.href.indexOf('/pages/size-guide') > -1) {
  sizeGuideInit();
  populateSelect();
}